import React, { FC, MouseEvent, useCallback, useContext } from 'react'

import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'

import {
  IconComponentType,
} from '../../types/app'

import EditorContext from './EditorContext'

import {
  IVoidCallback,
} from '@kaidam/fc-shared/src/types/utils'

interface ToolbarButtonProps {
  title: string,
  className?: string,
  icon: IconComponentType,
  active: boolean,
  disabled?: boolean,
  onClick: IVoidCallback,
}

const ToolbarButton: FC<React.PropsWithChildren<ToolbarButtonProps>> = ({
  title,
  className,
  icon,
  active,
  disabled,
  onClick,
}) => {
  const Icon = icon

  const editorContext = useContext(EditorContext)

  const onClickHandler = useCallback((e: MouseEvent) => {
    onClick()
    setTimeout(() => {
      editorContext.focus()
    }, 0)
  }, [
    onClick,
  ])
  
  return (
    <Tooltip title={ title } arrow placement="right">
      <span>
        <IconButton
          size="small"
          className={ className }
          disabled={ disabled }
          onClick={ onClickHandler }
          onMouseDown={(e) => e.preventDefault()}
        >
          <Icon color={ disabled ? "disabled" : active ? "secondary" : "primary" } fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default ToolbarButton